import "date-fns";
import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { UrlServicesContext } from "../../components/UrlServicesContext";

import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { green } from "@material-ui/core/colors";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  alert_background: {
    color: "#F7F00B",
    background: "#000",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
  },
  containerForm: {
    padding: "3%",
  },
  buttonSubmit: {
    marginTop: "4%",
    color: "#000",
    background: "#F7F00B",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
    "&:hover": {
      backgroundColor: "#000",
      color: "#F7F00B",
    },
  },
  input: {
    borderBottom: "1.2px solid #000",
    marginTop: "10px",
    padding: "5px 0 6px",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function UpdateProduct(props) {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_success, setMensaje_success] = useState("");
  const [imagen, setImagen] = useState("");
  const [loader, setLoader] = useState(true);

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = useRef();

  const { urlServices, urlImgServicesProductos } = useContext(
    UrlServicesContext
  );

  const [values, setValues] = useState({
    nombre: "",
    descripcion: "",
    precio: "",
  });

  const [errorField, setErrorField] = useState({
    nombre: false,
    descripcion: false,
    precio: false,
  });

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const onChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  useEffect(() => {
    clearTimeout(timer.current);

    const data = new FormData();
    data.append("id", props.id);

    const consultar = async () => {
      await axios
        .post(
          urlServices + "routes.php?servicio=consultarModificarProducto",
          data
        )
        .then(
          (response) => {
            if (response.data.code === 0) {
              setImagen(urlImgServicesProductos + response.data.result.imagen);
              setValues({
                ...values,
                nombre: response.data.result.nombre,
                descripcion: response.data.result.descripcion,
                precio: response.data.result.precio,
              });

              setLoader(false);
            } else {
              setLoader(false);
            }
          },
          (error) => {
            setLoader(false);
            setError(true);
          }
        );
    };

    consultar();
  }, [urlServices, props.id, urlImgServicesProductos]);

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);

    setErrorField({
      ...errorField,
      nombre: false,
      descripcion: false,
      precio: false,
    });

    if (values.nombre.length === 0) {
      setMensaje_error('El campo "Nombre Producto" es obligatorio!');
      setOpenAlert(true);
      setErrorField({ ...errorField, nombre: true });
    } else if (values.descripcion.length === 0) {
      setMensaje_error('El campo "Descripción" es obligatorio!');
      setOpenAlert(true);
      setErrorField({ ...errorField, descripcion: true });
    } else if (values.precio.length === 0) {
      setMensaje_error('El campo "Precio" es obligatorio!');
      setOpenAlert(true);
      setErrorField({ ...errorField, precio: true });
    } else {
      if (!loading) {
        setSuccess(false);
        setLoading(true);
        timer.current = setTimeout(() => {
          setSuccess(true);
          setLoading(false);
        }, 2000);
      }

      const data = new FormData();
      data.append("id", props.id);
      data.append("nombre", values.nombre);
      data.append("descripcion", values.descripcion);
      data.append("precio", values.precio);

      axios
        .post(urlServices + "routes.php?servicio=modificarProducto", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
              setMensaje_success("Modificado con exito!");
              props.callBackRefresh(true);
            } else {
              setError(true);
              setMensaje_error("Hubo un error al modificar!");
            }
          },
          (error) => {
            console.log(error);
            setError(true);
            setMensaje_error("Error al consultar el servicio API!");
          }
        );
    }
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <Alert
          severity="info"
          elevation={6}
          variant="filled"
          className={classes.alert_background}
        ></Alert>
        <DialogContent dividers>
          {!loader ? (
            <Fragment>
              <center>
                <img
                  src={imagen}
                  width="150"
                  alt="imgProducto"
                  style={{ border: "1px solid #F7F00B", objectFit: "cover" }}
                ></img>
              </center>

              <form onSubmit={submitForm} noValidate autoComplete="off">
                <Grid container spacing={2} className={classes.containerForm}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      error={errorField.nombre}
                      name="nombre"
                      value={values.nombre}
                      onChange={onChange("nombre")}
                      fullWidth
                      required
                      inputProps={{ maxLength: 30 }}
                      label="Nombre producto"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      error={errorField.precio}
                      name="precio"
                      value={values.precio}
                      onChange={onChange("precio")}
                      fullWidth
                      required
                      inputProps={{ maxLength: 5 }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9-.]/g, "");
                      }}
                      label="Precio (Ej: 5.50)"
                      margin="dense"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      error={errorField.descripcion}
                      name="descripcion"
                      value={values.descripcion}
                      onChange={onChange("descripcion")}
                      fullWidth
                      required
                      inputProps={{ maxLength: 99 }}
                      label="Descripción"
                      margin="dense"
                      multiline
                    />
                  </Grid>
                </Grid>
                <br></br>
                <center>
                  <Button
                    className={classes.buttonSubmit}
                    type="submit"
                    variant="contained"
                    size="medium"
                    disabled={loading}
                  >
                    Modificar
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}

                  {error ? <Alert severity="error">{mensaje_error}</Alert> : ""}
                  {success ? (
                    <Alert severity="success">{mensaje_success}</Alert>
                  ) : (
                    ""
                  )}
                </center>
              </form>
            </Fragment>
          ) : (
            <Fragment>
              <center>
                {" "}
                <CircularProgress />
              </center>
            </Fragment>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog(true)}
            variant="contained"
            size="medium"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity="error"
            elevation={6}
            variant="filled"
          >
            {mensaje_error}
          </Alert>
        </Slide>
      </Snackbar>
    </Fragment>
  );
}
